export class GridResultEnum
{
  static Search = "search";
  static Modified = "modified";
  static Sync = "sync";
  static Containermapping = "containermapping";
  static Basemapping = "basemapping";
  static OnboardedApp = "onboardedapp";
}
